<template>
  <pop-up-layout
    :title="localization.title"
    :description="localization.subtitle"
    :loading="loading"
    :saving="waitingForLoad"
    :disabled="!cambiado"
    @volver="cerrarPopup()"
  >
    <Alerts></Alerts>
    <v-col cols="12">
      <v-row class="pl-6">
        <v-col cols="4" md="4">
          <v-text-field
            id="nombre"
            v-model="nombre"
            :label="localization.nombre"
            :disabled="currentProvider !== null"
          />
        </v-col>
        <v-col cols="4" md="4">
          <v-text-field
            id="email"
            v-model="email"
            :label="localization.email"
            :disabled="currentProvider !== null"
          />
        </v-col>
        <v-col cols="4" md="4">
          <v-text-field
            id="telefono"
            v-model="telefono"
            :label="localization.telefono"
            :disabled="currentProvider !== null"
          />
        </v-col>
        <v-col cols="12" md="12" v-if="idubapi.rolProveedorWeb || idubapi.rolProveedor">
          <v-select
            v-model="promocionesSeleccionadasActor"
            id="promocionesSeleccionadasActor"
            :items="promotionsActor"
            :item-text="codenamePromocion"
            item-value="id"
            :label="localization.promociones"
            multiple
            clearable
            persistent-hint
            color="primary"
            :disabled="currentProvider === null"
          >
          <!--
          <template v-slot:append>
            {{ $t('soloProveedorWeb')}}
          </template>
          -->
          </v-select>

        </v-col>
        <v-col cols="6" md="6">
          <v-flex mb-2>
            <v-btn 
              color="primary" 
              right
              @click="updateProviderActor"
              :loading="buttonLoading"
            >
              {{localization.guardar}}
            </v-btn>
            <v-btn 
              class="ml-4"
              color="primary" 
              right
              @click="clear"
              :loading="buttonLoading"
            >
              {{localization.cancelar}}
            </v-btn>
        </v-flex>
        </v-col>
      </v-row>
      <v-row justify="center" class="px-6">
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :search="search"
            :items="this.$store.state.gestion.actorsProvider"
            item-key="code"
            :footer-props="{
              'items-per-page-options': [5, 10, 15, 20],
              'items-per-page-text': $t('filasPorPagina'),
            }"
            :items-per-page="5"
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr
                  v-for="item in items"
                  :key="item.code"
                  @click="seleccionarProveedor(item)"
                  :style="selected.id === item.id ? 'background-color: lightgray' : ''"
                >
                  <td class="text-xs-left">{{ item.nombre }}</td>
                  <td class="text-xs-left">{{ item.email }}</td>
                  <td class="text-xs-left">{{ item.telefono }}</td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-col>

    <ConfirmDialog @close="confirmarCrearProveedor()" :text="textoConfirmacion"
      @cancel="dialogConfirmacion = false" :dialogFlag="dialogConfirmacion" :textoBoton="textoAceptar" :textoTitulo="tituloCrearActor" />
    
  </pop-up-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import rulesMixin from '@/components/generic/rules.js'
import Alerts from '@/components/Alerts'

import ConfirmDialog from '../../custom/confirmDialog'

export default {
  components: {
    Alerts,
    ConfirmDialog
  },
  mixins: [rulesMixin],
  props: {
    yaSeleccionado: {
      type: Array,
      default: () => []
    },
    provider: {
      type: Object,
      default: () => {}
    },
    multiple: {
      type: Boolean,
      default: false
    },
    proveedorId: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      textoConfirmacion: this.$t('verIncidencia').dialogConfirmacion.textoConfirmarActorProveedor,
      textoCrearActorDeProveedorConActor: this.$t('verIncidencia').dialogConfirmacion.textoCrearActorDeProveedorConActor,
      tituloCrearActor: this.$t('verIncidencia').dialogConfirmacion.titulo,
      textoAceptar: this.$t('verIncidencia').dialogConfirmacion.boton,
      textoEmailProveedorVacio: this.$t('verIncidencia').dialogConfirmacion.textoEmailProveedorVacio,
      textoTitleEmailEmpty: this.$t('verIncidencia').dialogConfirmacion.textoTitleEmailEmpty,
      dialogConfirmacion: false,

      waitingForLoad: false,
      buttonLoading: false,
      loading: false,
      search: null,
      selected: [],
      items: [],
      seleccionarTodosLosResultados: false,
      regionSelected: [],
      sectorSelected: [],
      marcarProvincias: false,
      marcarSectores: false,
      nombre: null,
      movil: null,
      telefono: null,
      email: null,
      idActor: null,
      promocionesSeleccionadasActor: [],
      currentProvider: null
    }
  },
  async created () {
    try {
      
      this.loading = true
      this.selected = this.yaSeleccionado.length !== 0 ? this.promociones.filter(x => {
        return this.yaSeleccionado.some(y => {
            return x.promocionId === y.promocionId
        })
      }) : []
      this.loading = false
    } catch (error) {
      console.log('error', error)
      this.addAlert({ texto: this.$t('errorCargarPromociones'), color: 'error' })
    }
  },
  computed: {
    ...mapGetters({
      idubapi: 'login/idubapi',
      getConfiguracion: 'configuracion/getConfiguracion'
    }),
    localization () {
      return this.$t('popUpActoresProveedor')
    },
    headers () {
      return [
        {text: this.localization.nombre, value: 'nombre', sortable: true, align: 'LEFT'},
        {text: this.localization.email, value: 'email', sortable: true, align: 'LEFT'},
        {text: this.localization.telefono, value: 'telefono', sortable: false, align: 'LEFT'},
        // {text: this.localization.opciones, value: 'opciones', sortable: false, align: 'LEFT'}
      ]
    },
    promociones () {
      if (this.$store.state.incidencias.promociones) {
          let promociones = []
           if(this.regionSelected.length > 0 || this.sectorSelected.length > 0) {
                this.$store.state.incidencias.promociones.forEach(promocion => {
                  if ( (this.regionSelected.length > 0 && this.sectorSelected.length > 0) && this.regionSelected.includes(promocion.region) && this.sectorSelected.includes(promocion.sectorCode) ) {
                    promociones.push(promocion)
                  }
                  else if ( (this.regionSelected.length > 0 && this.sectorSelected.length == 0) && this.regionSelected.includes(promocion.region) ) {
                    promociones.push(promocion)
                  }
                  else if ( (this.regionSelected.length == 0 && this.sectorSelected.length > 0) && this.sectorSelected.includes(promocion.sectorCode) ) {
                    promociones.push(promocion)
                  }  
                });  
                return promociones.map(x => {
                    return {
                    ...x,
                    nombreCompleto: x.code + ' - ' + x.name
                    }
                })
           }
           else {
               return this.$store.state.incidencias.promociones.map(x => {
                    return {
                    ...x,
                    nombreCompleto: x.code + ' - ' + x.name
                    }
                })
           }
          
      }
      return []
    },
    cambiado () {
      return this.yaSeleccionado !== this.selected
    },
    promotionsActor () {
      return this.$store.state.gestion.promotionsActor
    },
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      getPromotionsByActor: 'gestion/getPromotionsByActor',
      updateProviderActorPromotion: 'gestion/updateProviderActorPromotion',
      crearActorAsociadoRolProveedor: 'incidencias/crearActorAsociadoRolProveedor',
      updateProviders: 'incidencias/updateProviders',
      getActorsProvider: 'gestion/getActorsProvider',
      
    }),
    clear () {
      this.promocionesSeleccionadasActor = []
      this.nombre = null
      this.movil = null
      this.telefono = null
      this.email = null
      this.selected = []
      this.currentProvider = null
    },
    async loadEditActor(item) {
      this.buttonLoading = true
      this.currentProvider = item
      this.idActor = item.id
      this.nombre = item.nombre
      this.movil = item.movil
      this.telefono = item.telefono
      this.email = item.email
      this.promocionesSeleccionadasActor = []
        await Promise.all[
          await this.getPromotionsByActor(this.currentProvider),
          this.$store.state.gestion.promotionsActor.map(promocion => {
            if ( promocion.selected == '1' ) {
              this.promocionesSeleccionadasActor.push(promocion.id)
            }
          })
        ]
        this.buttonLoading = false
    },
    codenamePromocion (item) {
      return item.code + ' - ' + item.descripcion
    },
    seleccionarProveedor (proveedor) {
      this.loadEditActor(proveedor)
      this.selected = proveedor
      
    },
    confirmar () {
      this.$emit('selected', this.selected)
      this.$parent.$parent.sheet = true
      this.$parent.hide()
    },
    marcarDesmarcarTodasPromociones () {
        let promociones = []
        if (this.seleccionarTodosLosResultados === true) {
            this.selected = []
            promociones = this.promociones
            promociones.forEach(promocion => {
                this.selected.push(promocion)
            });
        }
        else {
            this.selected = []
        }
    },
    marcarDesmarcarTodasProvincias () {
        this.borrarSeleccionados()
        let provincias = []
        if (this.marcarProvincias === true) {
            this.regionSelected = []
            provincias = this.provincias
            provincias.forEach(provincia => {
                this.regionSelected.push(provincia)
            });
        }
        else {
            this.regionSelected = []
        }
    },
    marcarDesmarcarTodosSectores () {
        this.borrarSeleccionados()
        let sectores = []
        if (this.marcarSectores === true) {
            this.sectorSelected = []
            sectores = this.sectores
            sectores.forEach(sector => {
                this.sectorSelected.push(sector.id)
            });
        }
        else {
            this.sectorSelected = []
        }
    },
    borrarSeleccionados () {
      this.selected = []
      this.seleccionarTodosLosResultados = false
    },
    cerrarPopup() {
      this.$parent.hide()
      this.$parent.$parent.sheet = true
    },
    
    async confirmarCrearProveedor() {
      
      this.buttonLoading = true

      const newItem = {
          email: this.email,
          id: this.provider.id,
          movil: this.provider.movil,
          phone: this.provider.phone,
          name: this.nombre,
          altaIncidencias: this.provider.altaIncidencias,
          gestionEstados: this.provider.gestionEstados
        }

      try {
        // eslint-disable-next-line no-constant-condition
        await this.updateProviders(newItem)
        
        await this.crearActorAsociadoRolProveedor(this.provider.id)
        
        this.addAlert({texto: this.$t('accesoAppConcedido'), color: 'success'})
      } catch (error) {
        
        this.addAlert({texto: error.message, color: 'error'})
      }

      newItem.email = this.provider.email
      newItem.name = this.provider.name
      
      await this.updateProviders(newItem)
              
      await this.getActorsProvider(this.provider.id)
      this.buttonLoading = false

      this.dialogConfirmacion = false
    },

    async updateProviderActor() {
      if(this.currentProvider === null) {
        this.dialogConfirmacion = true
        return
        
      } else {
        let form = {
          id: this.idActor,
          id_proveedor: this.currentProvider.id_proveedor,
          nombre: this.nombre,
          movil: this.movil,
          telefono: this.telefono,
          email: this.email,
          promociones: this.promocionesSeleccionadasActor
        }
        this.buttonLoading = true
        try {
          await this.updateProviderActorPromotion(form)
          this.buttonLoading = false

          this.addAlert({texto: this.$t('datosModificados'), color: 'success'})

        } catch (error) {
          console.log(error)
          this.buttonLoading = false
          this.addAlert({ texto: this.$t('errorCargarPromociones'), color: 'error' })
        }        

      }
      

      this.loadEditActor(this.currentProvider)
    }
  }
}
</script>

<style scoped>
  .info-tooltip {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.54);
    font-weight: bold;
    margin-bottom: 0px;
  }
</style>